// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"table-module--tableContainer--2947B","heading":"table-module--heading--EGEv8"};